import { jwtDecode } from 'jwt-decode';
import { IToolManagementFilter } from '../models/IToolManagementFilter';

export const getUserType = () => localStorage.getItem('oms_userType');

export const getToken = () => localStorage.getItem('oms_token');

export const getRefreshToken = () => localStorage.getItem('oms_refreshToken');

export const getUserName = () => localStorage.getItem('oms_userName');

export const getUserId = () => localStorage.getItem('oms_userId');

export const getParamType = () => localStorage.getItem('oms_paramType');

export const getTimeZone = () => localStorage.getItem('oms_timezoneId');

export const getdebuglogsfilter = () =>
  localStorage.getItem('oms_debugLogFilter');

export const getTenantIdFromLocalStorage = () =>
  localStorage.getItem('oms_access_tenant_id');

export const getFactoryIdFromLocalStorage = () =>
  localStorage.getItem('oms_access_tenant_id');

export const getToolBOMFactoryIdFromLocalStorage = () =>
  localStorage.getItem('oms_tool_bom_factory_id');

export const setToolBOMFactoryIdToLocalStorage = (factoryId: string) =>
  localStorage.setItem('oms_tool_bom_factory_id', factoryId);

export const clearToolBOMFactoryIdFromLocalStorage = () =>
  localStorage.removeItem('oms_tool_bom_factory_id');

export const getTokenFromLocalStorage = () => {
  const token = localStorage.getItem('oms_token');
  return token ? token : '';
};

export const getToolManagementSelectedToolType = () =>
  localStorage.getItem('oms_toolManagementToolType');

export const setToolManagementSelectedToolType = (toolType: number) =>
  localStorage.setItem('oms_toolManagementToolType', String(toolType));

export const getToolManagementFilterFromLocalStorage = (): IToolManagementFilter | null => {
  const raw = localStorage.getItem('oms_toolManagementFilter');
  if (!raw) return null;
  try {
    return JSON.parse(raw) as IToolManagementFilter;
  } catch {
    return null;
  }
};

export const setToolManagementFilterToLocalStorage = (filter: IToolManagementFilter) =>
  localStorage.setItem('oms_toolManagementFilter', JSON.stringify(filter));

export const clearToolManagementFilterFromLocalStorage = () =>
  localStorage.removeItem('oms_toolManagementFilter');

export const getRoleNameFromLocalStorage = () => {
  const roleName = localStorage.getItem('oms_role_name');
  return roleName ? roleName : '';
};

export const getTenantIdFromToken = () => {
  const token = localStorage.getItem('oms_token');
  let tenantId: any = 0;
  if (token !== null && token !== '') {
    const userToken: any = jwtDecode(token);
    tenantId = userToken.tenantId;
  }
  return parseInt(tenantId);
};

export const getOrgIdFromToken = () => {
  const token = localStorage.getItem('oms_token');
  let orgId: any = '';
  if (token !== null && token !== '') {
    const userToken: any = jwtDecode(token);
    orgId = userToken.organizationId;
  }
  return orgId;
};

export const getUserIdFromToken = () => {
  const token = localStorage.getItem('oms_token');
  let userId: any = 0;
  if (token !== null && token !== '') {
    const userToken: any = jwtDecode(token);
    userId = userToken.userId;
  }
  return parseInt(userId);
};

export const getProductIdFromToken = () => {
  // let token = localStorage.getItem("oms_token");
  // let userId:any = 0;
  // if (token !== null && token !== "") {
  //   const userToken: any = jwtDecode(token);
  //   userId = userToken.userId;
  // }
  // return parseInt(userId);
  return 0;
};

export const getUserEmailFromToken = () => {
  const token = localStorage.getItem('oms_token');
  let userEmail = '';
  if (token !== null && token !== '') {
    const userToken: any = jwtDecode(token);
    userEmail = userToken.userEmail;
  }
  return userEmail;
};

export const getTenantAccessFromLocalStorage = (): any => {
  const tenantId = localStorage.getItem('oms_access_tenant_id');
  return tenantId ? parseInt(tenantId) : -1;
};

export const getIsTenantAccessFromLocalStorage = (): any => {
  const isTenantAccess = localStorage.getItem('oms_is_access_tenant');
  return isTenantAccess ? JSON.parse(isTenantAccess) : false;
};

export const getUserTypeFromLocalStorage = () => {
  const userType = localStorage.getItem('oms_userType');
  return userType ? userType : '';
};

export const getLanguageFromLocalStorage = () => {
    let language = localStorage.getItem('oms_language');
    return language ? language : 'jp';
}
